export default "__VITE_ASSET__wOFwZWuB__"